
import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n, { loadTenantTranslations } from "../i18n";
import { HospitalContext } from "./HospitalProvider";

export const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

// Known patient-facing tenant slugs that can appear as the 2nd path segment
// of /patient/{tenant}/... URLs. "gi2" is part of the GI tenant so it maps to "gi".
const PATIENT_TENANT_SLUGS = { gi: "gi", gi2: "gi", mayo: "mayo" };

function tenantFromPath() {
  if (typeof window === "undefined") return null;
  const parts = window.location.pathname.split("/").filter(Boolean);
  // e.g. ["patient", "gi", "landing", ":eventId"]
  if (parts[0] === "patient" && parts[1]) {
    return PATIENT_TENANT_SLUGS[parts[1].toLowerCase()] || null;
  }
  return null;
}


export const LanguageProvider = ({ children }) => {
  const hospitalContext = useContext(HospitalContext);
  const hospital = hospitalContext?.hospital;
  const { pathname } = useLocation();

  const [lang, setLang] = useState("en");
  const [tenant, setTenant] = useState(
    hospital?.name?.toLowerCase() || tenantFromPath() || "default"
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const derived = hospital?.name?.toLowerCase() || tenantFromPath() || "default";
    setTenant(derived);
  }, [pathname, hospital]);

  useEffect(() => {
    async function init() {
      setReady(false);

      await i18n.changeLanguage(lang);
      await loadTenantTranslations(lang, tenant);

      setReady(true);
    }

    init();
  }, [lang, tenant]);

  return (
    <LanguageContext.Provider
      value={{
        lang,
        setLang,
        tenant,
        setTenant,
        ready
      }}
    >
      {ready ? children : null}
    </LanguageContext.Provider>
  );
};